import * as checkoutExchange from '@wix/auto_sdk_loyalty_checkout-exchange';
import * as imports from '@wix/auto_sdk_loyalty_imports';
import * as socialMedia from '@wix/auto_sdk_loyalty_social-media';
import * as transactions from '@wix/auto_sdk_loyalty_transactions';
import * as accounts from '@wix/auto_sdk_loyalty_accounts';
import * as coupons from '@wix/auto_sdk_loyalty_coupons';
import * as earningRules from '@wix/auto_sdk_loyalty_earning-rules';
import * as programs from '@wix/auto_sdk_loyalty_programs';
import * as rewards from '@wix/auto_sdk_loyalty_rewards';
import * as tiers from '@wix/auto_sdk_loyalty_tiers';

export {
  checkoutExchange,
  imports,
  socialMedia,
  transactions,
  accounts,
  coupons,
  earningRules,
  programs,
  rewards,
  tiers,
};
